import { makeStyles } from "@material-ui/core/styles";

/** Styles for the Professional Details card and its edit dialog — kept independent of the
 * Professional Contacts card's styles so each card stays a genuinely self-contained unit (§2a). */
const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: "var(--color-background-paper)",
    border: "1px solid var(--total_row_boldbackground)",
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 2, 0),
  },
  cardHeaderTitle: {
    fontSize: "0.9375rem",
    fontWeight: 700,
    color: "var(--color-text-primary)",
  },
  cardBody: {
    padding: theme.spacing(1.75, 2, 2),
  },
  title: {
    fontSize: "1.05rem",
    fontWeight: 700,
    color: "var(--color-text-primary)",
    margin: 0,
  },
  subtle: {
    color: "var(--color-text-secondary)",
    fontSize: "0.75rem",
  },
  hint: {
    color: "var(--color-text-secondary)",
    fontSize: "0.6875rem",
  },
  sectionHeading: {
    fontSize: "0.6875rem",
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "var(--color-text-secondary)",
    fontWeight: 700,
    margin: theme.spacing(1.5, 0, 0.75),
  },
  roleCard: {
    border: "1px solid var(--total_row_boldbackground)",
    borderRadius: "calc(8px * var(--app-radius-scale, 1))",
    padding: theme.spacing(1.25, 1.5),
    marginBottom: theme.spacing(1.25),
  },
  roleCardHead: {
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(1),
  },
  roleDates: {
    display: "flex",
    gap: theme.spacing(2.5),
    flexWrap: "wrap",
    fontSize: "0.75rem",
    marginTop: 4,
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(2.5),
    alignItems: "start",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  dialogPaper: {
    // Fills whatever width the Dialog's own maxWidth/fullWidth props give the paper — do not
    // also cap the width here, or the content sits left-anchored inside a wider paper instead
    // of filling it (that was the bug: a fixed width with no margin: 0 auto to center it).
    width: "100%",
  },
  dialogSubtitle: {
    color: "var(--color-text-secondary)",
    fontSize: "0.75rem",
    margin: theme.spacing(0.5, 0, 1.5),
    paddingTop: theme.spacing(1),
    borderTop: "1px solid var(--total_row_boldbackground)",
  },
  quoteRow: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    marginBottom: theme.spacing(0.75),
  },
  quoteDocumentRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    marginLeft: theme.spacing(0.25),
    marginBottom: theme.spacing(0.75),
  },
  quoteDocumentChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    fontSize: "0.75rem",
    color: "var(--color-text-primary)",
    backgroundColor: "var(--total_row_boldbackground)",
    borderRadius: "calc(6px * var(--app-radius-scale, 1))",
    padding: theme.spacing(0.25, 0.75),
    maxWidth: 170,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  quoteDocumentError: {
    color: "var(--color-error-main, #d32f2f)",
    fontSize: "0.6875rem",
    marginLeft: theme.spacing(0.25),
    marginBottom: theme.spacing(0.75),
  },
  linkAction: {
    color: "var(--color-primary-text)",
    cursor: "pointer",
    fontSize: "0.75rem",
    "&:hover": { textDecoration: "underline" },
  },
  validationSummary: {
    color: "var(--color-error-main, #d32f2f)",
    fontSize: "0.8125rem",
    backgroundColor: "color-mix(in srgb, var(--color-error-main, #d32f2f) 10%, transparent)",
    border: "1px solid var(--color-error-main, #d32f2f)",
    borderRadius: "calc(8px * var(--app-radius-scale, 1))",
    padding: theme.spacing(1, 1.5),
    marginBottom: theme.spacing(1.5),
  },
}));

export default useStyles;
